class Planet {
    constructor(name, description){
        this.name = name;
        this.description = description;
    }
}

export const planetStore = ()=>{
    const planets = [
        new Planet("Aqua", "Aqua Earth: An ocean-covered world or aquaplanet in Earth's orbit around the Sun. The climate simulations are based on an Earth-like atmosphere"),
        new Planet("PCB", "Proxima Centauri b: The nearest exoplanet to earth, orbiting a smaller and colder star (M-dwarf) compared to the Sun. It orbits at 1/25th the Earth-Sun distance and is tidally locked.  The climate simulations are based on an Earth-like atmosphere.")
    ]

    const map = ()=>Object.assign({}, ...planets.map((x) => ({[x.name]: x})));
    const data = (planet)=>map()[planet];

    const variables = ["temperature", "wind speed"]
    



    return {
        planets,
        map,
        data,
        variables
    }
}

export default planetStore;